import styled from 'styled-components'

export const ResultContainer = styled.div`
  margin-bottom: var(--ontario-spacing-8);
  max-width: 48rem;
  width: 100%;

  p {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    margin: var(--ontario-spacing-1) var(--ontario-spacing-0);
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    text-overflow: ellipsis;
  }

  &:first-of-type {
    margin-top: var(--ontario-spacing-7);
  }

  p.resource-format-wrapper {
    display: flex;
    align-items: center;
    gap: var(--ontario-spacing-4);
    align-self: stretch;
  }
  .resource-format {
    display: flex;
    align-items: center;
    gap: var(--ontario-spacing-4);
  }
  p.resource-format span.heading-default {
    color: var(--Grayscale-60, #666);
    font-family: 'Open Sans';
    font-size: 1rem;
    font-style: normal;
    font-weight: var(--ontario-font-weights-normal);
    line-height: var(--ontario-font-line-heights-default);
  }

  p.resource-last-validated-date {
    color: var(--Grayscale-60, #666);
    font-family: 'Open Sans';
    font-size: 1rem;
    font-style: italic;
    font-weight: var(--ontario-font-weights-normal);
    line-height: var(--ontario-font-line-heights-default);
  }

  .popular-badge-inline {
    display: inline;
  }

  .elaws-regulation-number {
    font-weight: bold;
    font-family: 'Raleway Modified', 'Helvetica Neue', Helvetica, Arial,
      sans-serif;
    margin-bottom: var(--ontario-spacing-1);
  }

  .elaws-highlight {
    background: #f8e5c3;
    mix-blend-mode: multiply;
    display: inline;
  }
`

export const ResultHeading = styled.h4`
  font-family: 'Raleway', 'Open Sans', 'Helvetica Neue', Helvetica, Arial,
    sans-serif;
  letter-spacing: 0.02rem;
  margin: var(--ontario-spacing-4) var(--ontario-spacing-0)
    var(--ontario-spacing-1);

  a {
    text-decoration: none;
    color: var(--ontario-colour-system-link);

    &:hover,
    &:focus {
      text-decoration: underline;
    }

    &:hover {
      color: var(--ontario-colour-system-link-hover);
    }

    &:active {
      color: var(--ontario-colour-system-link-active);
    }

    &:visited {
      color: var(--ontario-colour-system-link-visited);
    }
  }
`
